__turbopack_context__.v({
  "checkbox": "index-module__hTi9qq__checkbox",
  "checkmark": "index-module__hTi9qq__checkmark",
  "sr-only": "index-module__hTi9qq__sr-only",
});
